import { Lightbulb, MessageCircle, Zap } from 'lucide-react';

// Story beats data for the 3-act structure
export const STORY_BEATS = {
  1: {
    name: "Setup",
    description: "Introduce your protagonist, their world, and the conflict.",
    beats: [
      { id: "opening_image", name: "Opening Image", description: "The first impression of your story. Sets tone and mood.", suggested_scenes: 1, tips: "Show your protagonist in their ordinary world." },
      { id: "theme_stated", name: "Theme Stated", description: "Someone states the theme or lesson of the story.", suggested_scenes: 1, tips: "Often disguised as casual dialogue." },
      { id: "setup", name: "Set-Up", description: "Establish the protagonist's world and what's missing.", suggested_scenes: 3, tips: "Show flaws, desires, and the status quo." },
      { id: "catalyst", name: "Catalyst", description: "The event that sets the story in motion.", suggested_scenes: 1, tips: "A clear moment that changes everything." },
      { id: "debate", name: "Debate", description: "The protagonist debates whether to accept the challenge.", suggested_scenes: 2, tips: "What's holding them back?" },
      { id: "break_into_two", name: "Break Into Two", description: "The protagonist chooses to enter Act 2.", suggested_scenes: 1, tips: "Must be a decision, not something that happens to them." }
    ]
  },
  2: {
    name: "Confrontation",
    description: "Your protagonist pursues their goal and faces obstacles.",
    beats: [
      { id: "b_story", name: "B Story", description: "Introduce a subplot that carries the theme.", suggested_scenes: 2, tips: "Often a love interest or mentor." },
      { id: "fun_and_games", name: "Fun and Games", description: "The promise of the premise.", suggested_scenes: 5, tips: "Why the audience came to see your movie." },
      { id: "midpoint", name: "Midpoint", description: "A false victory or defeat that raises stakes.", suggested_scenes: 2, tips: "No going back after this." },
      { id: "bad_guys_close_in", name: "Bad Guys Close In", description: "External pressure mounts, internal doubts emerge.", suggested_scenes: 4, tips: "Things fall apart." },
      { id: "all_is_lost", name: "All Is Lost", description: "The lowest point.", suggested_scenes: 1, tips: "Often involves a symbolic death." },
      { id: "dark_night", name: "Dark Night of the Soul", description: "Processing loss and finding strength.", suggested_scenes: 2, tips: "Where the theme clicks." }
    ]
  },
  3: {
    name: "Resolution",
    description: "The protagonist applies what they've learned.",
    beats: [
      { id: "break_into_three", name: "Break Into Three", description: "Armed with new understanding, the protagonist fights.", suggested_scenes: 1, tips: "Solution comes from B Story or theme." },
      { id: "finale", name: "Finale", description: "The final confrontation.", suggested_scenes: 4, tips: "Prove transformation by facing the antagonist." },
      { id: "final_image", name: "Final Image", description: "Mirror of Opening Image showing change.", suggested_scenes: 1, tips: "Show how much has changed." }
    ]
  }
};

// Choice steps for the collaborative scene creation flow
export const CHOICE_STEPS = [
  { id: "plot", name: "Plot Direction", description: "Choose the key story moment for this beat", icon: Lightbulb },
  { id: "dialogue", name: "Dialogue Approach", description: "Select the conversational style", icon: MessageCircle },
  { id: "character_action", name: "Character Actions", description: "Define character movements and reactions", icon: Zap }
];

// Free tier beat access - Extended to include first Act 2 beat for better conversion
export const FREE_TIER_BEATS = ["opening_image", "theme_stated", "setup"];
